import { FeatureFlagManifest } from "./check-feature-flag";

export const featureFlags = {
    cpapiwdConfluenceTemplateDetails: {
        featureFlagName: "cpapi-wd-confluence-template-details",
        metadata: {
            description:
                "Feature gate to roll out cpapi deprecation for Confluence Template Details pages",
            expectedReleaseDate: "5/19/2025",
            expectedRuntime: "1 week",
            context: {
                urls: ["/software/confluence/templates/*"]
            }
        }
    },
    cpapiwdConfluenceTemplateCollectionDetails: {
        featureFlagName: "cpapi-wd-confluence-template-collection-details",
        metadata: {
            description:
                "Feature gate to roll out cpapi deprecation for Confluence Template Collection Details pages",
            expectedReleaseDate: "5/19/2025",
            expectedRuntime: "1 week",
            context: {
                urls: ["/software/confluence/templates/collections/*"]
            }
        }
    },
    cpapiwdPricingAll: {
        featureFlagName: "cpapi-wd-pricing-all-gate",
        metadata: {
            description:
                "Feature gate to roll out CPAPI deprecation for Pricing pages (excluding Jira Pricing)",
            expectedReleaseDate: "4/24/2025",
            expectedRuntime: "5 weeks",
            context: {
                urls: [
                    "/software/confluence/pricing",
                    "/software/jira/service-management/pricing",
                    "/software/jira/product-discovery/pricing",
                    "/software/bitbucket/pricing",
                    "/software/rovo/pricing",
                    "/software/compass/pricing",
                    "/software/guard/pricing",
                    "/teams/nonprofits/discount-pricing",
                    "/software/loom/pricing",
                    "/collections/teamwork/pricing",
                    "/collections/strategy/pricing"
                ]
            }
        }
    },
    sxpEnableFastshiftPortal: {
        featureFlagName: "sxp-enable-fastshift-portal",
        metadata: {
            description: "Feature gate to roll out Migration FastShift Portal",
            expectedReleaseDate: "07/01/2025",
            expectedRuntime: "Duration of FastShift's first release",
            context: {
                urls: ["/fastshift/dashboard"]
            }
        }
    },
    wacUniformPromotionRoutesToSqs: {
        featureFlagName: "wac-uniform-promotion-routes-to-sqs",
        metadata: {
            description: "Feature gate to send routes to SQS for Uniform",
            expectedReleaseDate: "2/25/2025",
            expectedRuntime: "",
            context: {
                urls: ["/customers/*"]
            }
        }
    },
    cpapiwdAgileHubGate: {
        featureFlagName: "cpapi-wd-agile-hub-gate",
        metadata: {
            description:
                "Feature gate to roll out Contenful query to replace cpapi query for Agile Hub",
            expectedReleaseDate: "5/09/2025",
            expectedRuntime: "1 week",
            context: {
                urls: ["/agile/*"]
            }
        }
    },
    cpapiwdCustomerLanding: {
        featureFlagName: "cpapi-wd-customer-landing",
        metadata: {
            description:
                "Feature gate to roll out cpapi deprecation for Customer Stories Landing page",
            expectedReleaseDate: "4/16/2025",
            expectedRuntime: "1 week",
            context: {
                urls: ["/customers"]
            }
        }
    },
    gwp1304AddIntercomToJpdProductTour: {
        featureFlagName: "gwp-1304-add-intercom-to-jpd-product-tour",
        metadata: {
            description: "Add Intercom to JPD Product Tour",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira/product-discovery"]
            }
        }
    },
    jfindCheckGupsForLoggedOutUsers: {
        featureFlagName: "jfind-check-gups-for-logged-out-users",
        metadata: {
            description:
                "Get sites info for logged out users on Jira product tour",
            expectedReleaseDate: "4/14/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/software/jira"]
            }
        }
    },
    jfindJsmPaidEditionsMigration: {
        featureFlagName: "jfind-jsm-paid-editions-migration",
        metadata: {
            description: "Move JSM paid editions off of Bxpkit",
            expectedReleaseDate: "5/14/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    jfindSendAnchoredTeamTypeToGups: {
        featureFlagName: "jfind-send-anchored-team-type-to-gups",
        metadata: {
            description: "Send anchored team type to gups",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["*"]
            }
        }
    },
    wacUipLocalizeLinkHref: {
        featureFlagName: "wac-uip-localize-link-href",
        metadata: {
            description: "WAC UIP Localize Link Href",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["*"]
            }
        }
    },
    wacWebExtendedCachingOfBfldrAssetsForJsw: {
        featureFlagName: "wac-web-extended-caching-of-bfldr-assets-for-jsw",
        metadata: {
            description: "WAC Web Extended Caching of Bfldr Assets for JSW",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira"]
            }
        }
    },
    wacWebTrafficAAGate: {
        featureFlagName: "wac-web-traffic-aa-gate",
        metadata: {
            description: "WAC Web Traffic AA Gate",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["*"]
            }
        }
    },
    gwp5158FocusProductAdd: {
        featureFlagName: "gwp-5158-focus-product-add",
        metadata: {
            description: "Adding Focus to global nav",
            expectedReleaseDate: "April 9, 2025",
            expectedRuntime:
                "Forever (gate to be used for Team launch, will be cleaned up)",
            context: {
                urls: ["*"]
            }
        }
    },
    jiraWizardPerfImproved: {
        featureFlagName: "jira_improve_wizard_perf",
        metadata: {
            description: "Jira Signup Wizard Perf Improved",
            expectedReleaseDate: "03/17/2025",
            expectedRuntime: "",
            context: {
                urls: ["*"]
            }
        }
    },
    gwp4947Team25HeroHomepageTakeover: {
        featureFlagName: "gwp-4947-team-25-hero-homepage-takeover",
        metadata: {
            description: "Team 25 hero takeover",
            expectedReleaseDate: "February",
            expectedRuntime: "Until April 8th",
            context: {
                urls: ["/", "/enterprise"]
            }
        }
    },
    gwp5046TurboBannerEnterprise: {
        featureFlagName: "gwp-5046-turbo-banner-enterprise",
        metadata: {
            description: "Turbo racing banner",
            expectedReleaseDate: "February",
            expectedRuntime: "Until April 8th",
            context: {
                urls: ["/enterprise"]
            }
        }
    },
    gwp5381AddIntercomWidgetToUniform: {
        featureFlagName: "gwp-5381-add-intercom-widget-to-uniform",
        metadata: {
            description: "Add Intercom widget to Uniform Page component",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/customers/*"]
            }
        }
    },
    wacProductsLoomURL: {
        featureFlagName: "wac-products-loom-url",
        metadata: {
            description: "Change loom URL",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["*"]
            }
        }
    },
    asyncArchitectureSiteCreation: {
        featureFlagName: "async-architecture-frontend-gate",
        metadata: {
            description:
                "Feature gate to enable async architecture site creation for JSM n2n",
            expectedReleaseDate: "03/31/2025",
            expectedRuntime: "",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    edgeLambdaCacheProductDiscovery: {
        featureFlagName: "edge-lambda-cache-product-discovery",
        metadata: {
            description:
                "Flag to enable edge lambda caching for product discovery page",
            expectedReleaseDate: "03/18/2025",
            expectedRuntime:
                "Can be cleaned up after monitored in PROD and ensure no issues",
            context: {
                urls: ["/software/jira/product-discovery", "/"]
            }
        }
    },
    wacWebUseEsModulesScripts: {
        featureFlagName: "wac-web-use-esmodules-scripts",
        metadata: {
            description: "Use Esmodules script",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["*"]
            }
        }
    },
    signupPopBackBtn: {
        featureFlagName: "signup-pop-back-btn",
        metadata: {
            description:
                "Show back button in post order signup site picker page",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/buy/cloud/site-setup"]
            }
        }
    },
    team25LoomPricingPage: {
        featureFlagName: "team25-loom-pricing-page",
        metadata: {
            description: "Team 25 Loom Pricing Page",
            expectedReleaseDate: "4/1/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/loom/pricing"]
            }
        }
    },
    gwp5548Team25DuringEventBanner: {
        featureFlagName: "gwp-5548-team-25-during-event-banner",
        metadata: {
            description: "Team 25 During event banner",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "1 day",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp5421CollectionsHero: {
        featureFlagName: "gwp-5421-collections-hero",
        metadata: {
            description: "Collections hero takeover on homepage",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    voltronEnterpriseContactForm: {
        featureFlagName: "voltron-enterprise-contact-form",
        metadata: {
            description: "Sends utms values in the form submission payload",
            expectedReleaseDate: "4/11",
            expectedRuntime: "indefinite",
            context: {
                urls: []
            }
        }
    },
    voltronGupsDataInAnalyticsWrapper: {
        featureFlagName: "voltron-gups-data-in-analytics-wrapper",
        metadata: {
            description:
                "Add gups storage and retrieval of utm data in analytics wrapper",
            expectedReleaseDate: "4/11/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp5618CollectionsGlobalNav: {
        featureFlagName: "gwp-5618-collections-global-nav",
        metadata: {
            description: "Collections global nav",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["*"]
            }
        }
    },
    gwp5585ProductToAppGlobalNav: {
        featureFlagName: "gwp-5585-product-to-app-global-nav",
        metadata: {
            description: "Product -> App on global nav",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["*"]
            }
        }
    },
    gwp737EnableIntercomChatHome: {
        featureFlagName: "gwp-737-enable-intercom-chat-home",
        metadata: {
            description: "Triggers boot intercom on home page",
            expectedReleaseDate: "",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    wacLiftedBannerSticky: {
        featureFlagName: "wac-lifted-banner-sticky",
        metadata: {
            description: "Lifted banner sticky",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/",
                    "/software/confluence",
                    "/jira",
                    "/software/jira/service-management",
                    "/software/jira"
                ]
            }
        }
    },
    gwp5682RemoveRovoFromPricingForm: {
        featureFlagName: "gwp-5682-remove-rovo-from-pricing-form",
        metadata: {
            description: "Remove rovo from pricing form",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/enterprise/contact"]
            }
        }
    },
    wacHomepageLoggedInHero: {
        featureFlagName: "wac-homepage-loggedin-hero",
        metadata: {
            description:
                "Homepage logged in hero skeleton loader for logged in users",
            expectedReleaseDate: "4/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    jiraProductDiscoveryPremiumWacUpdates: {
        featureFlagName: "jira-product-discovery-premium-wac-updates",
        metadata: {
            description:
                "Updates to the JPD Pricing page on WAC for Premium GA. https://hello.jira.atlassian.cloud/browse/GWP-5783",
            expectedReleaseDate: "4/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/jira/product-discovery/pricing"]
            }
        }
    },
    siteActivationGate: {
        featureFlagName: "jfind-1062-site-activation-gate",
        metadata: {
            description:
                "Uses feature gate the run site activation code instead of site name code.",
            expectedReleaseDate: "4/30/2025",
            expectedRuntime: "1 week",
            context: {
                urls: ["/try/cloud/signup "]
            }
        }
    },
    jiraPassTeamTypeParameter: {
        featureFlagName: "jira_pass_teamtype_param",
        metadata: {
            description:
                "Pass teamType parameter safely to Jira for wizard project create",
            expectedReleaseDate: "28/05/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp3944SigninPrompt: {
        featureFlagName: "gwp-3944-signin-prompt-loggedout-gate",
        metadata: {
            description: "Signin prompt",
            expectedReleaseDate: "5/2/2025",
            expectedRuntime: "",
            context: {
                urls: ["/"]
            }
        }
    },
    gwpRelayConfTemplateCollectionDetails: {
        featureFlagName: "gwp-3063-relay-conf-template-collections-gate",
        metadata: {
            description:
                "Add Relay to Confluence Template Collection Details pages",
            expectedReleaseDate: "4/30/2025",
            expectedRuntime: "2 week",
            context: {
                urls: ["/software/confluence/templates/collections/*"]
            }
        }
    },
    gwpRelayConfTemplateDetails: {
        featureFlagName: "gwp-3063-relay-conf-template-details-gate",
        metadata: {
            description: "Add Relay to Confluence Template Details pages",
            expectedReleaseDate: "4/30/2025",
            expectedRuntime: "2 week",
            context: {
                urls: ["/software/confluence/templates/*"]
            }
        }
    },
    enterprisePageDXPMigration: {
        featureFlagName: "enterprise-page-dxp-migration",
        metadata: {
            description: "Enterprise Page DXP Migration",
            expectedReleaseDate: "7/1/2025",
            expectedRuntime: "",
            context: {
                urls: ["/enterprise"]
            }
        }
    },
    jiraTemplatesDxpMigration: {
        featureFlagName: "jira-templates-dxp-migration",
        metadata: {
            description: "Jira Templates DXP Migration",
            expectedReleaseDate: "6/30/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira/*"]
            }
        }
    },
    gwp6289Team25EuBanner: {
        featureFlagName: "gwp-6289-team-25-eu-banner",
        metadata: {
            description: "GWP-6289 Team 25 Europe banner",
            expectedReleaseDate: "5/19/2025",
            expectedRuntime: "3 weeks",
            context: {
                urls: ["/"]
            }
        }
    },
    wacRecaptchaFlag: {
        featureFlagName: "wac-recaptcha-flag",
        metadata: {
            description: "Wac Recaptcha Migration GWP-6220",
            expectedReleaseDate: "5/19/2025",
            expectedRuntime: "Operational Flag",
            context: {
                urls: ["*"]
            }
        }
    }
} satisfies FeatureFlagManifest;
